import { Box, Grid, Typography, Checkbox } from "@material-ui/core";

import CardTextInput from "../../../../components/CardTextInput/CardTextInput";
import CustomTextField from "../../../../components/CustomTextField/CustomTextField";
import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { CustomSwitch } from "../../../../components/Switch/Switch";
import CustomPhoneNumber from "../../../../components/CustomPhoneNumber/CustomPhoneNumber";
import OptiumLogo from "../../../../assets/img/optium-logo.png";
import SafePurchase from "../../../../assets/img/safe-purchase.png";
import PlusIcon from "../../../../assets/img/plus.svg";
import CloseIcon from "../../../../assets/img/close-tab.svg";
import useStyles from "./styles";
import { useEffect } from "react";

const cvvState = [];

const CardsForms = ({
  fields,
  currentValues,
  defaultCardValues,
  addNewCard,
  billingAddress,
  splitPaymentValue,
  remove,
  setValue,
  formType,
}) => {

  useEffect(() => {
    currentValues.forEach((card, index) => {
        if (typeof(cvvState[index]) === 'undefined') {
          cvvState[index] = {isStrip: card.cardNumber.includes('-')}
        } else {
          const isStrip = card.cardNumber.includes('-')
          if (cvvState[index].isStrip && cvvState[index].isStrip !== isStrip) {
            setValue(`cards[${index}].cvv`, '', { shouldValidate: true })
          }
          cvvState[index].isStrip = isStrip
        }
      });

      Object.keys(cvvState).forEach(index => {
        if (!currentValues[index]) {
          delete cvvState[index]
        }
      })
  });
  const classes = useStyles();
  const handleShowBilling = (index, selectedOption) => {
    if (index !== 0 && selectedOption === "default") {
      return false;
    }
    return true;
  };

  const deletFormCard = (idx) => {
    if (currentValues.length === 2) {
      remove(idx);
      setValue("splitPayment", false);
    } else {
      remove(idx);
    }
  };

  const hideCardChars = (card) => {
    const lastDigits = card.slice(card.length - 4);
    return `●●●● ●●●● ●●●● ${lastDigits}`;
  };

  // window.states = [
  //   {
  //     "label": "Canada",
  //     "code": "CA",
  //     "states": [
  //       {
  //         "label": "Quebec",
  //         "code": "QC"
  //       },
  //       {
  //         "label": "Quebec1",
  //         "code": "QC1"
  //       },
  //       {
  //         "label": "Quebec2",
  //         "code": "QC2"
  //       },
  //       {
  //         "label": "Quebec3",
  //         "code": "QC3"
  //       },
  //       {
  //         "label": "Quebec4",
  //         "code": "QC4"
  //       }
  //     ]
  //   },
  //
  //   {
  //     "label": "Moldova",
  //     "code": "MD",
  //     "states": []
  //   }
  // ]

  const statesRawData = window.states ?? []

  const countryOptions = statesRawData.map((country) => ({
    value: country.code,
    label: country.label,
  })) ?? [];

  const stateOptions = fields.map((field, index) => {
      return statesRawData
        .find((country) => country.code === currentValues?.[index]?.country)?.states
        .map((state) => ({
          value: state.code,
          label: state.label,
        })) ?? [];
  })

  const getValue = (field, index = 0) => {
      return (index === 0 || currentValues[index]?.billingAddress !== "other")
        ? currentValues[0]?.[field]
        : currentValues[index]?.[field] || defaultCardValues[field]
  }

  return (
    <>
      {fields.map((field, index) => (
        <Grid container spacing={1} key={field?.id}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            mb={2}
            mt={3}
            style={{ position: "relative", width: "100%" }}
          >
            <Typography variant="h2" align="center">
              Billing Details
            </Typography>
            <Typography variant="body1" align="center">
              Please fill in your credit card information
            </Typography>
          </Box>
          <Grid item xs={12}>
            <CardTextInput
              label="Credit/Debit Card Number"
              formType={formType}
              defaultValue={
                formType === "view"
                  ? hideCardChars(currentValues[index]?.cardNumber)
                  : currentValues[index] ? currentValues[index].cardNumber : defaultCardValues.cardNumber
              }
              name={`cards[${index}].cardNumber`}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              label="Card Holder's Name"
              defaultValue={
                currentValues[index]?.cardHolderName ||
                defaultCardValues.cardHolderName
              }
              name={`cards[${index}].cardHolderName`}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomDatePicker
              label="Expiration date mm/yy"
              name={`cards[${index}].expirationDate`}
              defaultValue={
                currentValues[index]?.expirationDate ||
                defaultCardValues.expirationDate
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label="CVV"
              defaultValue={currentValues[index]?.cvv || defaultCardValues.cvv}
              name={`cards[${index}].cvv`}
              type={formType === "view" ? "password" : "tel"}
              maxCharacterLimit={4}
            />
          </Grid>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            mb={2}
            mt={4}
            style={{width: '100%'}}
          >
            <Typography variant="h2" align="center">
              Billing Address
            </Typography>
            <Typography variant="body1" align="center">
              Your billing address must be entered exactly as it appears on your credit card statement
            </Typography>
          </Box>
          {index > 0 && (
            <Grid item xs={12}>
              <Box>
                <CustomSelect
                  name={`cards[${index}].billingAddress`}
                  label={billingAddress.label}
                  options={billingAddress.options}
                  defaultValue={fields[index]?.billingAddress || "default"}
                  location="billing"
                />
              </Box>
            </Grid>
          )}
          {handleShowBilling(
            index,
            currentValues[index]?.billingAddress ||
              fields[index]?.billingAddress
          ) && (
            <>
              <Grid item xs={12}>
                {
                  (!countryOptions.length || formType === 'view' || getValue('country', index)?.length > 3) ?
                    <CustomTextField
                      label="Country"
                      defaultValue={getValue('country', index)}
                      name={`cards[${index}].country`}
                    /> :
                    <CustomSelect
                      name={`cards[${index}].country`}
                      options={countryOptions}
                      label="Country"
                      withoutEmpty
                      defaultValue={getValue('country', index)}
                    />
                }


              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  label="City"
                  defaultValue={
                    index === 0 ||
                    currentValues[index]?.billingAddress !== "other"
                      ? currentValues[0]?.city
                      : currentValues[index]?.city || defaultCardValues.city
                  }
                  name={`cards[${index}].city`}
                />
              </Grid>
              <Grid item xs={12}>
                {
                  (!stateOptions[index].length || formType === 'view' || getValue('state', index)?.length > 3) ?
                  <CustomTextField
                    label="State"
                    defaultValue={getValue('state', index)}
                    name={`cards[${index}].state`}
                  /> :
                  <CustomSelect
                    name={`cards[${index}].state`}
                    options={stateOptions[index]}
                    label="State"
                    withoutEmpty
                    defaultValue={getValue('state', index)}
                  />
                }
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  label="Street Address"
                  maxCharacterLimit="255"
                  defaultValue={
                    index === 0 ||
                    currentValues[index]?.billingAddress !== "other"
                      ? currentValues[0]?.street
                      : currentValues[index]?.street || defaultCardValues.street
                  }
                  name={`cards[${index}].street`}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  label="Zip / Postal Code"
                  defaultValue={
                    index === 0 ||
                    currentValues[index]?.billingAddress !== "other"
                      ? currentValues[0]?.postalCode
                      : currentValues[index]?.postalCode ||
                        defaultCardValues.postalCode
                  }
                  name={`cards[${index}].postalCode`}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  label="Email"
                  defaultValue={
                    index === 0 ||
                    currentValues[index]?.billingAddress !== "other"
                      ? currentValues[0]?.cardHolderEmail
                      : currentValues[index]?.cardHolderEmail ||
                        defaultCardValues.cardHolderEmail
                  }
                  name={`cards[${index}].cardHolderEmail`}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomPhoneNumber
                  label="Bank Phone Number"
                  name={`cards[${index}].cardPhoneNumber`}
                  defaultValue={
                    index === 0 ||
                    currentValues[index]?.billingAddress !== "other"
                      ? currentValues[0]?.cardPhoneNumber
                      : currentValues[index]?.cardPhoneNumber ||
                        defaultCardValues.cardPhoneNumber
                  }
                />
              </Grid>
            </>
          )}
          {index === 0 && (
            <Box mt={1}>
              <CustomSwitch
                name="splitPayment"
                value={splitPaymentValue}
                label={
                  <>
                    <Typography variant="body2">Split Payment</Typography>
                    <Typography variant="body1">
                      Add up to 4 credit cards and split the payment between them!
                    </Typography>
                  </>
                }
              />
            </Box>
          )}
          {index > 0 && (
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                className={classes.removeCard}
                mb={1}
                onClick={() => {
                  deletFormCard(index);
                }}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mr={1}
                >
                  <img src={CloseIcon} alt="plus" />
                </Box>
                <Typography variant="subtitle2">Remove This Card</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      ))}
      {fields.length > 1 && fields.length < 4 && (
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className={classes.addNewBtn}
            onClick={() => {
              addNewCard();
            }}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mr={1}
            >
              <img src={PlusIcon} alt="plus" />
            </Box>
            <Typography variant="subtitle2">ADD ANOTHER CREDIT CARD</Typography>
          </Box>
        </Grid>
      )}
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row"
        mt={2}
      >
        <Box
          className={classes.footerLogo}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <img src={SafePurchase} alt="optium-logo" />
        </Box>
        <Box
          className={classes.footerLogo}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <img src={OptiumLogo} alt="optium-logo" />
        </Box>
      </Box>
    </>
  );
};

export default CardsForms;
